<template>
    <div class="container auth-container valign-wrapper" id="otp-container" style="height: auto; margin-top: 25px">
        <div class="row">
            <div class="col s12 m12 center-align">
                <!-- Step 1 -->
                <div class="card" v-if="step === 1">
                    <div class="card-content">
                        <span class="card-title" v-if="resetPasswordAction && !path">Please key in your phone number</span>
                        <span class="card-title" v-if="!resetPasswordAction && !path">Please key in your phone number to register an account</span>
                        <span class="card-title" v-if="path == 'mobile/verification'">Please key in your phone number to verify your account</span>
                        <div class="row">
                            <div class="input-field col s12">
                                <i class="material-icons prefix">local_phone</i>
                                <input autocomplete="new-password" id="phone_no" type="text" placeholder="eg: 01712XXXXX" v-model="phone_no">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col s12">
                                <a class="waves-effect waves-light btn" v-on:click="phoneSubmitAction" v-if="!is_button_loading">Confirm</a>
                                <a class="btn disabled" v-if="is_button_loading">Submitting...</a>
                            </div>
                            <div class="col s12" style="margin-top: 10px" v-if="path == 'mobile/verification'">
                                <!--<a href="/attempt/login">Do it later</a>-->
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Step 2 -->
                <div class="card otp-input" v-if="step === 2">
                    <div class="card-content">
                        <span class="card-title">Verify Your Mobile Number</span>
                        <p class="sub">We have sent an OTP on your <br> mobile number {{ phone_no }}</p>
                        <div class="row">
                            <div class="col s12">
                                <div class="userInput">
                                    <input inputmode="numeric" pattern="[0-9]*" autocomplete="new-password" type="text" :disabled="is_loading"  v-model="input1" id="first" maxlength="1" v-on:keyup="clickEvent($event,'sec')">
                                    <input inputmode="numeric" pattern="[0-9]*" autocomplete="new-password" type="text" :disabled="is_loading"  v-model="input2" id="sec" maxlength="1" v-on:keyup="clickEvent($event,'third')">
                                    <input inputmode="numeric" pattern="[0-9]*" autocomplete="new-password" type="text" :disabled="is_loading"  v-model="input3" id="third" maxlength="1" v-on:keyup="clickEvent($event,'fourth')">
                                    <input inputmode="numeric" pattern="[0-9]*" autocomplete="new-password" type="text" :disabled="is_loading"  v-model="input4" id="fourth" maxlength="1" v-on:keyup="clickEvent($event,'fifth')">
                                    <input inputmode="numeric" pattern="[0-9]*" autocomplete="new-password" type="text" :disabled="is_loading"  v-model="input5" id="fifth" maxlength="1" v-on:keyup="clickEvent($event,'sixth')">
                                    <input inputmode="numeric" pattern="[0-9]*" autocomplete="new-password" type="text" :disabled="is_loading"  v-model="input6" id="sixth" maxlength="1">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col s12" style="margin-bottom: 15px;">
                            <countdown :time="300000" @progress="handleCountdownProgress">
                                <template slot-scope="props">{{ props.minutes }}:{{ props.seconds }}</template>
                            </countdown>
                        </div>
                        <div class="col s12 resend-btn-col" v-if="is_show_resend_otp">
                            <a href="#" v-on:click="resendOtp">Resend OTP</a>
                        </div>
                    </div>
                </div>

                <!-- Step 3 -->
                <div class="card" v-if="step === 3">
                    <div class="card-content">
                        <span class="card-title">Please create a new password for your account</span>
                        <div class="row">
                            <div class="input-field col s12 m12">
                                <i class="material-icons prefix">dialpad</i>
                                <input id="password" type="password" name="password" class="validate" v-model="password" required>
                                <label for="password">Password</label>
                                <div v-if="this.submitted && $v.password.$error" class="invalid-feedback left">
                                    <span class="helper-text red-text" v-if="!$v.password.required">Password is required</span>
                                    <span class="helper-text red-text" v-if="!$v.password.minLength">The password must be at least 8 characters.</span>
                                    <span class="helper-text red-text" v-if="password && !$v.password.sameAsPassword">Password and Confirm Password should match</span>
                                </div>
                            </div>
                            <div class="input-field col s12 m12">
                                <i class="material-icons prefix">dialpad</i>
                                <input id="password_confirmation" name="password_confirmation" type="password" class="validate" v-model="confirmation_password" required>
                                <label for="password_confirmation">Confirmation Password</label>
                                <div v-if="this.submitted && $v.confirmation_password.$error" class="invalid-feedback left">
                                    <span class="helper-text red-text" v-if="!$v.confirmation_password.required">Confirm Password is required</span>
                                    <span class="helper-text red-text" v-if="confirmation_password && !$v.confirmation_password.sameAsPassword">Password and Confirm Password should match</span>
                                </div>
                            </div>
                            <div class="col s12">
                                <a class="waves-effect waves-light btn" :disabled="this.isDisabled" v-on:click="registerAfterValidOTP">Confirm</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col s12">
                <img class="responsive-img" :src="otpBanner">
            </div>
        </div>
    </div>
</template>

<script>
import { required, sameAs, minLength } from 'vuelidate/lib/validators'
import "moment-duration-format"

export default {
    name: "OtpComponent",
    props: [
        'path',
        'email',
        'loginOtpIndexUrl',
        'resetPasswordAction',
        'otpBanner'
    ],
    data () {
        return {
            step: 1,
            phone_no: '',
            is_loading: false,
            is_show_resend_otp: false,

            input1: '',
            input2: '',
            input3: '',
            input4: '',
            input5: '',
            input6: '',

            password: '',
            confirmation_password: '',
            submitted: false,

            is_button_loading: false,
            minute: 0,
            second: 0,
            countdown: 300, // 5min
        }
    },
    validations: {
        password: {
            required,
            minLength: minLength(8)
        },
        confirmation_password: { required, sameAsPassword: sameAs('password') }
    },
    watch: {
      otp (val) {
          if (val) {
              let me = this

              if (this.email) {
                  axios.post('/verify/otp', {
                      phone_no: this.phone_no,
                      email: this.email,
                      otp: this.otp
                  })
                      .then(function (response) {
                          if (response.data.success) {
                              Swal.fire({
                                  position: 'center',
                                  icon: 'success',
                                  title: response.data.message,
                                  showConfirmButton: false,
                                  timer: 1500,
                                  allowOutsideClick: false
                              }).then((result) => {
                                  /* Read more about handling dismissals below */
                                  if (result.dismiss === Swal.DismissReason.timer) {
                                      me.step++;
                                  }
                              })
                          }
                          else {
                              Swal.fire({
                                  position: 'center',
                                  icon: 'error',
                                  title: response.data.message,
                                  showConfirmButton: false,
                                  timer: 1500,
                                  allowOutsideClick: false
                              }).then((result) => {
                                  /* Read more about handling dismissals below */
                                  if (result.dismiss === Swal.DismissReason.timer) {
                                      me.is_loading = false
                                      me.input1 = ''
                                      me.input2 = ''
                                      me.input3 = ''
                                      me.input4 = ''
                                      me.input5 = ''
                                      me.input6 = ''
                                  }
                              })
                          }
                      })
                      .catch(function (error) {
                          console.log(error);
                      });
              }
              else {
                  axios.post('/verify/register/otp', {
                      otp: this.otp
                  })
                      .then(function (response) {
                          if (response.data.success) {
                              Swal.fire({
                                  position: 'center',
                                  icon: 'success',
                                  title: response.data.message,
                                  showConfirmButton: false,
                                  timer: 1500,
                                  allowOutsideClick: false
                              }).then((result) => {
                                  /* Read more about handling dismissals below */
                                  if (result.dismiss === Swal.DismissReason.timer) {
                                      me.step++
                                  }
                              })
                          }
                          else {
                              Swal.fire({
                                  position: 'center',
                                  icon: 'error',
                                  title: response.data.message,
                                  showConfirmButton: false,
                                  timer: 1500,
                                  allowOutsideClick: false
                              }).then((result) => {
                                  /* Read more about handling dismissals below */
                                  if (result.dismiss === Swal.DismissReason.timer) {
                                      me.is_loading = false
                                      me.input1 = ''
                                      me.input2 = ''
                                      me.input3 = ''
                                      me.input4 = ''
                                      me.input5 = ''
                                      me.input6 = ''
                                  }
                              })
                          }
                      })
                      .catch(function (error) {
                          console.log(error);
                      });
              }
          }
      }
    },
    created () {

        if (this.path === 'mobile/verification')
        {
            console.log(this.email)

            if (this.email == '')
            {
                window.location.href = '/login'
            }
        }

        this.submitted = true
        return this.$v.$touch()
    },
    computed: {
      otp () {
          if (this.input1 !== '' && this.input2 !== '' && this.input3 !== '' && this.input4 !== '' && this.input5 !== '' && this.input6 !== '') {
              this.is_loading = true
              return this.input1+this.input2+this.input3+this.input4+this.input5+this.input6
          }
          else {
              return ''
          }
       },
       isDisabled () {
          return this.$v.$invalid
       },
    },
    mounted () {

    },
    methods: {
        handleCountdownProgress(data) {
            console.log(data.totalSeconds);

            if (data.totalSeconds === 1)
            {
                this.is_show_resend_otp = true
            }
        },
        clickEvent (event, last) {
            if (event.target.value) {
                document.getElementById(last).focus();
            }
        },
        phoneSubmitAction () {
            let me = this

            this.is_button_loading = true

            axios.post('/send/otp', {
                phone_no: this.phone_no,
                email: this.email,
                is_reset_password: this.resetPasswordAction
            })
                .then(function (response) {
                    if (response.data.success) {
                        me.step++;

                        me.phone_no = response.data.phone_no
                    }
                    else {
                        Swal.fire({
                            position: 'center',
                            title: 'Error!',
                            text: response.data.message,
                            icon: 'error',
                            confirmButtonText: 'Cancel',
                            allowOutsideClick: false,
                            footer: '<a href="'+ response.data.link +'">'+ response.data.link_text +'</a>'
                        })

                    }
                    me.is_button_loading = false
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        resendOtp () {
            let me = this
            axios.post('/send/otp', {
                phone_no: this.phone_no,
                email: this.email
            })
                .then(function (response) {
                    if (response.data.success) {
                        Swal.fire({
                            position: 'center',
                            icon: 'success',
                            title: response.data.message,
                            showConfirmButton: false,
                            timer: 1500,
                            allowOutsideClick: false
                        })
                    }
                    else {
                        Swal.fire({
                            position: 'center',
                            title: 'Error!',
                            text: response.data.message,
                            icon: 'error',
                            confirmButtonText: 'Cancel',
                            allowOutsideClick: false
                        })
                    }
                    me.phone_no = response.data.phone_no
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        registerAfterValidOTP () {
            let me = this

            axios.post('/verified/create/user/otp', {
                password: this.password,
                password_confirmation: this.confirmation_password,
                phone_no: this.phone_no
            })
                .then(function (response) {
                    if (response.data.success) {
                        Swal.fire({
                            position: 'center',
                            icon: 'success',
                            title: response.data.message,
                            showConfirmButton: false,
                            timer: 1500,
                            allowOutsideClick: false
                        }).then((result) => {
                            /* Read more about handling dismissals below */
                            if (result.dismiss === Swal.DismissReason.timer) {
                                window.location.href = '/profile'
                            }
                        })
                    }
                    else {
                        Swal.fire({
                            position: 'center',
                            title: 'Error!',
                            text: response.data.message,
                            icon: 'error',
                            confirmButtonText: 'Cancel',
                            allowOutsideClick: false
                        })
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    }
}
</script>

<style scoped>

</style>
